module.exports = __webpack_public_path__ + "img/20191212172601955.7a7d261b.jpg";